import React from 'react';
import $ from 'jquery';
import { Modules } from '../libs/utils/Const';
import '../css/responsive.css';
import { isMarketingDocument, isMarketingDocumentSAP } from '../libs/utils/GlobalFunc';



export const renderDataTableActions = (SearchInTable, createDocument, billing, view, openBussinesPartner, openInventoryData, handleInputChange, openConfigTableHeaders, generateCsv, flag, report,
    authorizationReport, getAllDocumentsToPrint, OpenAdministratorUsers, writeAccess, openFiguraTransporte, openTransporte, openCartaPorte, citiOption,
    ChangeAuthoPartnersAction, SendAuthorizations, createNewRouteDelivery, allowClose, closeDocumentsAsInvoice, closeDocuments, GetEntryTransfersData, OpenSuggestRefillModal, printDelivaryAcuse, openReconciliationModal,
    showGroupNumModal, CreateNewPriceList, OpenRegisterNomina, TimbraNomina, DescargaMasiva, OpenRegisterEmployeeNomina,
    printRoadmapPreview, importUsers, downloadUsersTemplate, DraftObjType = '540000006', BranchPermission, pendingCutsActions = {}
) => {
    let reporte = $('#selectDocTypeDocumentSearch2').val();
    let filter = $('#selectDocTypeDocumentStockValidator').val();
    const restrictedViews = [
        "middleware", "invoiceAuthorization", "invoiceBorrador", "bussinesPartner", "inventoryData", "administratorUsers", "invoiceAdvance", "figuresTransport", "transports", "consignmentNote",
        "pendingTimbraDoc", "citibanamex", "authorizePartners", "adminDeliveries20", "goodsReceiptProd", "goodsIssue", "rscMasterData", "salesForecast", "suggestRefill", "adminUsersMVentas", "priceLists",
        "draft",
        // Cortes pendientes es un reporte de solo lectura con acción propia por fila, no acciones genéricas de crear/editar.
        "timbNominas", "employeeNomina", "canalizadoTanque", "collectView", "reabsResume", "cutTransfers", "PurchaseOrder", "pendingCuts"
    ];

    const validDraftView = [ // Vistas en las cuales si se permite crear preliminares directos
        1250000001
    ]

    return (
        <div className='form-inline'>
            <div className="form-group ">
                {/* {!restrictedViews.includes(view) && writeAccess && ( */}
                {((!restrictedViews.includes(view)) || validDraftView?.includes(Number(DraftObjType))) && writeAccess && (
                    <button
                        className="btn btn-timbra-one btn-outline-secondary mr-sm-2 btnNuevo mr-1 mb-2"
                        onClick={createDocument}
                        style={{ width: 252, borderColor: "#A7A6A5" }}
                    >
                        <i className="far fa-file"></i> Nuevo Documento
                    </button>
                )}

                {view === 'invoiceAdvance' && writeAccess && Modules['InvoiceAdvance'] &&
                    <button className="btn btn-timbra-one btn-outline-secondary mr-sm-2 btnNuevo mr-1 mb-2" onClick={createDocument} style={{ width: 252, borderColor: "#A7A6A5" }} >
                        <i className="far fa-file"></i> Nuevo Documento
                    </button>
                }

                {(view === "orderSales") && writeAccess &&
                    false &&
                    <button className="btn btn-primary ml-sm-2 mr-sm-2 btnNuevo mr-1 mb-2" onClick={closeDocumentsAsInvoice} style={{ width: 252, borderColor: "#A7A6A5" }} >
                        <i className="fa fa-file" /> Copiar a Factura
                    </button>
                }
                {(view === "quotations" || view === "orderSales" || view === "PurchaseRequest" || view === "PurchaseOrder" || view === 'PurchaseQuotation' || view === "transfersRequest") && allowClose &&
                    <button className="btn btn-danger ml-sm-2 mr-sm-2 mb-2"
                        onClick={closeDocuments}
                        style={{ width: 252, borderColor: "#A7A6A5" }} >
                        <i className="fa fa-lock"></i> Cerrar Documentos
                    </button>
                }
                {view === 'timbNominas' && Modules['TimbNominas'] &&
                    <>
                        <button className="btn btn-timbra-one btn-outline-secondary mr-sm-2 btnNuevo mr-1 mb-2" onClick={OpenRegisterNomina} style={{ width: 252, borderColor: "#A7A6A5" }} >
                            <i className="far fa-file"></i> Registro de nomina
                        </button>

                        <button className={"btn  btn-timbra-one btn-outline-secondary mr-2 btnNuevo mr-1 mb-2"} onClick={() => TimbraNomina()} style={{ width: 250, borderColor: "#A7A6A5" }}>
                            <i className="fas fa-sync"></i> Timbrar nominas
                        </button>

                        <button className="btn btn-primary mr-sm-2 btnNuevo mr-1 mb-2" onClick={() => DescargaMasiva()} style={{ width: 250, borderColor: "#A7A6A5" }}>
                            <i className="fa fa-download"></i> Descarga masiva
                        </button>
                    </>
                }
                {view === 'employeeNomina' && Modules['TimbNominas'] &&
                    <>
                        <button className="btn btn-primary mr-sm-2 btnNuevo mr-1 mb-2" onClick={() => OpenRegisterEmployeeNomina()} style={{ width: 252, borderColor: "#A7A6A5" }} >
                            <i className="far fa-file"></i> Registro de empleado
                        </button>
                    </>
                }

            </div>

            <div className="form-group">
                {((view === "PurchaseOrder" || view === 'PurchaseQuotation') && writeAccess) && false &&
                    <div className="mr-sm-3" style={{ width: 252, borderColor: "#A7A6A5" }}>
                        <label className="btn btn-success text-white btn-outline-secondary mr-sm-2 ml-sm-2 btnNuevo" style={{ width: 252, borderColor: "#A7A6A5" }}> <i className="fa fa-search mr-sm-1"></i>
                            Buscar Excel
                            <input onChange={handleInputChange} type="file" name="file" id="file" style={{ display: 'none' }} />
                        </label>
                    </div>
                }
            </div>

            <br className="hide-pc" />
            {(view === 'payment') && writeAccess && Modules['InternalReconciliation'] &&
                <button className="btn  btn-timbra-one btn-outline-secondary mr-3 btnNuevo mb-2" onClick={openReconciliationModal} style={{ width: 250, borderColor: "#A7A6A5" }}>
                    <i className="fa fa-balance-scale"></i> Reconciliación Interna
                </button>}
            {
                (view === "invoice" || view === "invoiceReserve" || view === "debitNote" || view === "creditNote" || view === 'payment' || view === 'transfers' || view === "invoiceAdvance" || view === 'pendingTimbraDoc') &&
                <button className={view === "invoiceAdvance" ? "btn  btn-timbra-one btn-outline-secondary mr-3 btnNuevo mb-2" : "btn btn-timbra-one btn-outline-secondary btnNuevo mr-1 mb-2"} onClick={() => billing(1)} style={{ width: 250, borderColor: "#A7A6A5" }}>
                    <i className="fas fa-sync"></i> Timbrar
                </button>
            }
            <div className="form-group">
                {/* {((view === "orderSales" || view === "deliveries") && writeAccess && flag) && 
                    <button className="btn btn-outline-secondary btn-timbra-one  mr-sm-2 ml-sm-2" onClick={() => billing(2)} style={{width:250, borderColor: "#A7A6A5"}}>
                    <i className="fas fa-file-invoice"></i> Facturar
                </button>} */}
            </div>
            {/* CARTA PORTE */}
            <div className="form-group mb-2">
                {(view === "consignmentNote" && writeAccess) &&
                    <div className="">
                        <button className="btn btn-outline-secondary mr-sm-2 btnNuevo sugerido mt-1 mr-1 mb-2"
                            onClick={openCartaPorte} style={{ width: 252, borderColor: "#A7A6A5", height: 40 }}>
                            <i className="fas fa-user-plus"></i> Crear Carta Porte
                        </button>
                    </div>}
            </div>
            {/* SUGGEST REFILL MODULE */}
            <div className="form-group mb-2">
                {(view === "suggestRefill" && writeAccess) &&
                    <div className="">
                        <button className="btn btn-outline-secondary mr-sm-2 btnNuevo sugerido mr-1 crearsuge mb-2"
                            onClick={OpenSuggestRefillModal} style={{ width: 252, borderColor: "#A7A6A5", height: 40 }}>
                            <i className="fas fa-user-plus"></i> Crear Sugerido
                        </button>
                    </div>}
            </div>
            {
                (view === 'consignmentNote') //&&  timbra
                && <button className="btn btn-timbra-one btn-outline-secondary mr-sm-2 btnNuevo mr-1 cfdi-res mb-2" onClick={() => billing(9)} style={{ borderColor: "#A7A6A5" }}>
                    <i className="fas fa-sync"></i>
                    <span className="d-none d-xxl-inline"> Timbrar Documento</span>
                    <span className="d-inline d-xxl-none"> Timbrar</span>
                </button>
            }
            <div className="form-group">
                {(view === "invoiceBorrador" && writeAccess && (filter === 'W' || filter === '1')) &&
                    <button className="btn btn-success text-white btn-outline-secondary  mr-sm-2 btnNuevo mb-2" onClick={() => billing(3)} style={{ width: 250, borderColor: "#A7A6A5" }}>
                        <i className="fa fa-plus"></i> Crear
                    </button>}
                {(view === "invoiceBorrador" && writeAccess && (filter === 'PAR')) &&
                    <button className="btn btn-success text-white btn-outline-secondary  mr-sm-2 btnNuevo mb-2" onClick={() => billing(11)} style={{ width: 250, borderColor: "#A7A6A5" }}>
                        <i className="fa fa-edit"></i> Aprobar edición parcial
                    </button>}
            </div>
            {/* EMPRESA PIDIÓ QUE QUITÁRAMOS ESTE BOTON PORQUE LOS USUARIOS LA CAGABAN PERO SI FUNCIONA BIEN */}
            {/* <div className="form-group ">
                {(view === "invoiceBorrador" && writeAccess && (filter === 'W' || filter === '0' || filter === '1')) && <button className="btn btn-danger text-white btn-outline-secondary  mr-sm-2" onClick={() => billing(6)} style={{ width: 250, borderColor: "#A7A6A5" }}>
                    <i className="fa fa-times"></i> Cancelar
                </button>}
            </div> */}

            {view === "creditNote" && Modules['CancelCreditNotes'] &&
                <div className="form-group">
                    <button className="btn btn-danger text-white btn-outline-secondary ml-sm-2 mr-sm-2 btnNuevo mb-2" onClick={() => billing(10)} style={{ width: 250, borderColor: "#A7A6A5" }}>
                        <i className="fa fa-times"></i> Cancelar
                    </button>
                </div>
            }

            {(isMarketingDocumentSAP(view) || view === 'PurchaseRequest' || view === 'PurchaseQuotation' || view === 'PurchaseOrder') && (view === 'PurchaseOrder' ? Modules['Cancel_' + view] && BranchPermission?.CancelClosePurchaseOrder : Modules['Cancel_' + view]) &&
                <div className="form-group">
                    <button
                        className="btn btn-danger text-white btn-outline-secondary ml-sm-2 mr-sm-2 btnNuevo mb-2"
                        onClick={() => billing(12)}
                        style={{ width: 250, borderColor: "#A7A6A5" }}>
                        <i className="fa fa-times"></i> Cancelar
                    </button>
                </div>
            }

            {view === 'PurchaseOrder' && Modules['Close_' + view] && BranchPermission?.CancelClosePurchaseOrder &&
                <div className="form-group">
                    <button
                        className="btn btn-outline-danger ml-sm-2 mr-sm-2 btnNuevo mb-2"
                        onClick={() => billing(14)}
                        style={{ width: 250 }}>
                        <i className="fa fa-times"></i> Cerrar
                    </button>
                </div>
            }

            {view === 'payment' && Modules['Cancel_' + view] &&
                <div className="form-group">
                    <button
                        className="btn btn-danger text-white btn-outline-secondary ml-sm-2 mr-sm-2 btnNuevo mb-2"
                        onClick={() => billing(13)}
                        style={{ width: 250, borderColor: "#A7A6A5" }}>
                        <i className="fa fa-times"></i> Cancelar Pago
                    </button>
                </div>
            }

            <div className="form-group">
                {(view === "invoiceAuthorization" && writeAccess && reporte !== '---') && <>
                    <button id="btnAuthorization" className="btn botonCorrect btnNuevo mr-sm-2 d-block d-xl-none mb-2" onClick={() => billing(4)}>
                        <i className="fa fa-refresh"></i> Actualizar
                    </button>

                    <button id="btnAuthorization" className="btn botonCorrect btn-outline-secondary mr-sm-2 btn-flotante btnNuevo d-none d-xl-block mb-2" onClick={() => billing(4)} style={{ width: 250, borderColor: "#A7A6A5" }}>
                        <i className="fa fa-refresh"></i> Actualizar
                    </button>
                </>}
                {/* <a href="#" className="btn-flotante">Autorizar</a> */}
            </div>

            <div className="form-group">
                {(view === "invoiceAuthorization" && writeAccess && reporte === '---') && <button className="btn btn-success text-white btn-outline-secondary btnNuevo mr-sm-2 mb-2" onClick={() => authorizationReport()} style={{ width: 250, borderColor: "#A7A6A5" }}>
                    <i className="fa fa-check"></i> Generar Reporte
                </button>}
                {view === "pendingCuts" && <button
                    type="button"
                    className="btn btn-success text-white btn-outline-secondary btnNuevo mr-sm-2 mb-2"
                    onClick={pendingCutsActions.reprocess}
                    disabled={!pendingCutsActions.selectedCount}
                    style={{ width: 250, borderColor: "#A7A6A5" }}
                >
                    <i className="fa fa-refresh mr-1"></i> Reprocesar
                </button>}
                {view === "citibanamex" && writeAccess &&
                    <>
                        <button className="btn btn-success text-white btn-outline-secondary mr-4 btnNuevo mb-2" onClick={() => citiOption(1)} style={{ width: 250, borderColor: "#A7A6A5" }}>
                            <i className="fa fa-file mr-3"></i> Generar TXT
                        </button>

                        <button className="btn btn-success text-white btn-outline-secondary mr-2 btnNuevo mb-2" onClick={() => citiOption(2)} style={{ width: 250, borderColor: "#A7A6A5" }}>
                            <i className="fa fa-upload mr-3"></i> Cargar pagos
                        </button>
                    </>
                }
            </div>

            {/* <div className="form-group mb-2">
                {(view === "invoiceAuthorization" && readOnly) && <button className="btn btn-danger text-white btn-outline-secondary mr-sm-2 btn-flotante" onClick={() => billing(5)} style={{width:250, borderColor: "#A7A6A5", left:390}}>
                    <i className="fa fa-times"></i> Rechazar
                </button>}
            </div> */}

            {/* #region CARTA PORTE */}
            <div className="form-group mb-2">
                {(view === "figuresTransport" && writeAccess) && <button className="btn btn-outline-secondary btn-timbra-one mr-sm-3 btnNuevo sugerido mr-1 mb-2"
                    onClick={openFiguraTransporte} style={{ width: 260, borderColor: "#A7A6A5", height: 40 }}><i className="fas fa-user-plus"></i>
                    <span className="d-none d-xxl-inline"> Dar de Alta Figura Transporte</span>
                    <span className="d-inline d-xxl-none"> Alta Figura</span>
                </button>
                }
            </div>

            {/* <div className="form-group mb-2">
                {(view === "transports" && writeAccess) && <button className="btn btn-outline-secondary btn-timbra-one mr-sm-3"
                    onClick={openTransporte} style={{ width: 260, borderColor: "#A7A6A5", height: 40 }}>
                    <i className="fas fa-user-plus"></i> Dar de Alta Transporte
                </button>}
            </div> */}
            {/* #endregion */}


            <div className="form-group">
                {(view === "bussinesPartner" && writeAccess) &&
                    <>
                        <button className="btn btn-outline-secondary btn-timbra-one mr-sm-3 btnNuevo sugerido mr-1 mb-2"
                            onClick={openBussinesPartner} style={{ width: 252, borderColor: "#A7A6A5", height: 40 }}>
                            <i className="fas fa-user-plus"></i>
                            <span className="d-none d-xxl-inline"> Crear Socio de Negocios</span>
                            <span className="d-inline d-xxl-none"> Crear Socio</span>
                        </button>
                        {Modules.PaymentTerms &&
                            <button className="btn btn-outline-secondary btn-timbra-one mr-sm-3 btnNuevo mb-2"
                                onClick={() => showGroupNumModal(null, true)} style={{ width: 252, borderColor: "#A7A6A5", height: 40 }}>
                                <i className="fas fa-credit-card" />
                                <span className="d-none d-xxl-inline"> Condiciones de Pago</span>
                                <span className="d-inline d-xxl-none"> Condiciones</span>
                            </button>
                        }
                    </>
                }
            </div>

            <div className="form-group ">
                {(view === "administratorUsers" && writeAccess) && <button className="btn btn-outline-secondary btn-timbra-one mr-sm-3 btnNuevo sugerido mr-1 mb-2"
                    onClick={OpenAdministratorUsers} style={{ width: 252, borderColor: "#A7A6A5", height: 40 }}>
                    <i className="fas fa-user-plus"></i> Crear usuario
                </button>}
            </div>

            <div className="form-group ">
                {(view === "administratorUsers" && writeAccess) && (
                    <div className="mr-3 d-flex" style={{ width: 252 }}>
                        <label className="btn btn-success mr-3 btnNuevo sugerido" style={{ width: 252, height: 40 }}>
                            <i className="fa fa-file-excel-o mr-2" />
                            Abrir archivo
                            <input
                                onChange={importUsers}
                                type="file"
                                name="file"
                                id="file"
                                style={{ display: "none" }}
                                accept=".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                        </label>

                        <button className="btn btn-outline-success mb-2" title="Descargar Plantilla" onClick={downloadUsersTemplate}>
                            <i className="fa fa-cloud-download" />
                        </button>
                    </div>
                )}
            </div>

            <div className="form-group">
                {(view === "inventoryData" && writeAccess) &&
                    <button className="btn btn-outline-secondary btn-timbra-one mr-sm-3 btnNuevo sugerido mr-1 mb-2"
                        onClick={openInventoryData} style={{ width: 252, borderColor: "#A7A6A5", height: 40 }}>
                        <i className="fas fa-user-plus"></i>
                        <span className="d-none d-xxl-inline"> Datos Maestros del Artículo</span>
                        <span className="d-inline d-xxl-none"> Datos Maestros</span>
                    </button>}
            </div>

            {(view === "rscMasterData" && writeAccess) &&
                <div className="form-group ">
                    <button className="btn btn-timbra-one mr-sm-3 btnNuevo sugerido mr-1 mt-0 mb-2" onClick={createDocument} style={{ width: 252, borderColor: "#A7A6A5", height: 40 }}> <i className="fas fa-plus-circle mr-2" /> Nuevo Recurso </button>
                </div>
            }
            {(view === "priceLists" && writeAccess) && (
                <button
                    className="btn btn-timbra-one btn-outline-secondary mr-sm-2 btnNuevo mr-1 mb-2"
                    onClick={CreateNewPriceList}
                    style={{ width: 252, borderColor: "#A7A6A5" }}
                >
                    <i className="fas fa-plus"></i>
                    <span className="d-none d-xl-inline"> Crear nueva lista de precios</span>
                    <span className="d-inline d-xl-none"> Nueva lista</span>
                </button>
            )}

            <div className="form-group ">
                {(view !== "middleware" && view !== "invoiceAuthorization" && view !== "invoiceBorrador" && view !== "bussinesPartner"
                    && view !== "inventoryData" && view !== "administratorUsers" && view !== "invoiceAdvance" && view !== 'figuresTransport'
                    && view !== 'transports' && view !== 'consignmentNote' && view !== 'pendingTimbraDoc' && view !== 'authorizePartners'
                    && view !== "adminDeliveries20" && view !== "salesForecast" && view !== "mrpAssistant"
                    && view !== 'landedCosts'
                    && view !== "adminUsersMVentas"
                    && view !== "wareHouseAdmin"
                    && view !== "priceLists"
                    && view !== "canalizadoTanque"
                    && view !== 'collectView'
                    && view !== "reabsResume"
                    && view !== "cutTransfers"
                    && view !== "draft"
                ) && writeAccess && report &&
                    <div className="">
                        <button className="btn btn-success text-white btn-outline-secondary mr-sm-2 btnNuevo mr-1 mb-2"
                            style={{ width: 252, borderColor: "#A7A6A5" }} onClick={generateCsv}>
                            <i className="fa fa-file-excel-o mr-sm-1"></i> Generar reportes
                        </button>
                    </div>
                }
            </div>

            {
                view === 'authorizePartners' &&
                <>
                    <div className="autorizacionesres" style={{ display: 'flex' }}>
                        <label className="label-autorizaciones"><strong>Autorización: &nbsp;&nbsp;</strong></label>
                        <select
                            name="select"
                            className="btn-outline-secondary mr-2 select-responsive mb-1"
                            id="selectAuthoPartnersAction"
                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            onChange={(event) => ChangeAuthoPartnersAction(event.target.value)}
                        >
                            <option value="">Selecciona la autorización</option>
                            <option value="N">Rechazar</option>
                            <option value="Y">Autorizar</option>
                        </select>
                    </div>
                    <button
                        className="btn btn-warning mr-sm-2 btnNuevo sugerido mb-1 mb-2"
                        onClick={() => SendAuthorizations()}
                    >
                        Enviar autorizaciones
                    </button>
                </>
            }

            <div className="form-group ">
                {(view === "orderSales" || view === "invoice" || view === "deliveries" || view === "debitNote" || view === "creditNote" || view === "invoiceReserve" || view === "return" || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === "quotations" || view === "payment" || view === "transfers" || view === "transfersEntry" || view === "transfersOutput" || view === "transfersRequest"/*|| view === "outgoingPayment"*/) &&
                    <div className="">
                        <button className="btn btn-secondary text-white btn-outline-secondary btnNuevo mr-1 mb-2" style={{ width: 252, borderColor: "#A7A6A5" }} onClick={() => getAllDocumentsToPrint(1)} > <i className="fa fa-print" aria-hidden="true"></i> Imprimir</button>
                    </div>
                }
            </div>
            <div className="form-group ">
                {(view === 'PurchaseOrder') &&
                    <div className="">
                        <button className="btn btn-secondary text-white btn-outline-secondary btnNuevo mr-1 mb-2" style={{ width: 252, borderColor: "#A7A6A5" }} onClick={() => getAllDocumentsToPrint(2)} > <i className="fa fa-print" aria-hidden="true"></i> Imprimir OC</button>
                    </div>
                }
            </div>

            {view && view === 'transfers' &&
                <div className="form-group">
                    <div className="">
                        <button
                            className="btn btn-primary mr-sm-2 btnNuevo mb-2"
                            style={{ width: 200 }}
                            onClick={() => GetEntryTransfersData()} >
                            Informe de Entradas
                        </button>
                    </div>

                </div>
            }

            {
                view !== "invoiceAuthorization" && view !== "middleware" && view !== "pendingTimbraDoc" && view !== "citibanamex" &&
                <div className="form-group">
                    <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc mr-sm-2 input-responsive respinp sugerido mb-2' style={{ display: 'inline-block' }} placeholder="Buscar en tabla" autoComplete="off" id='searchDataTable'
                        type='search' aria-controls='dataTableTimbra' onChange={SearchInTable} />
                </div>
            }


            {/* <div className="form-group mb-2 MostarColumnas">708
                <button className="btnColumns" onClick={openConfigTableHeaders}
                                style={{fontWeight: '500', textAlign: 'right',}}>
                            
                            <i className="fas fa-cog"></i>Mostrar Columnas&nbsp;
                        </button>
            </div> */}









            {/* <br className="hide-pc"/> 
            &nbsp;&nbsp;
            <br className="hide-pc"/> 


            <div className=" col-md" style={{width: 250}}>
                
            </div>
            
            

            <br className="hide-pc"/> */}

        </div >
    )
}
